import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EmailtemplateService} from '../../emailtemplate.service';

declare let $;

@Component({
  selector: 'app-cloud-infra-manager',
  templateUrl: './cloud-infra-manager.component.html',
  styleUrls: ['./cloud-infra-manager.component.scss']
})
export class CloudInfraManagerComponent implements OnInit {

  @Input() selectedCloudInfra: any;
  @Output() selectedCloudInfraOutput = new EventEmitter<{}>();
  @Input() displayOnly = false;
  @Output() changed = new EventEmitter<{}>();
  selectedCloudInfraInComponent: any;
  ciSelected: any;
  regionSelected: any;
  cloudInfraList = [
    {
      cloudProvider: 'AWS',
      image: './assets/img/vault/awssecretsmanager.png',
      region: 'US-East (N.Virginia)',
      description: 'Host your applications in AWS',
      value: 'aws'
    },
    {
      cloudProvider: 'Azure',
      image: './assets/img/partnerOnboarding/azure.png',
      region: 'Central US',
      description: 'Host your applications in Azure',
      value: 'azure'
    },
    {
      cloudProvider: 'GCP',
      image: './assets/img/partnerOnboarding/gcp.png',
      region: 'US-East (N.Virginia)',
      description: 'Host your applications in GCP',
      value: 'gcp'
    },
    {
      cloudProvider: 'On Premise',
      image: './assets/img/partnerOnboarding/onPremises3.jpg',
      region: 'US-East (N.Virginia)',
      description: 'Host your applications on your premises',
      value: 'onpremise'
    }
  ];

  constructor(private emailTemplateInstance: EmailtemplateService) { }

  ngOnInit() {
    const that = this;
    $(document).ready(function () {
      for (let i = 0; i < that.cloudInfraList.length; i++) {
        if (that.cloudInfraList[i]['value'] === that.selectedCloudInfra) {
          const id = 'selectedCloudInfra' + i;
          $('#' + id).css('border', '2px solid #ff672d');
        }
      }
    });
    $(document).ready(function () {
      for (let i = 0; i < that.cloudInfraList.length; i++) {
        const id = 'selectedCloudInfra' + i;
        if (that.cloudInfraList[i].value === that.selectedCloudInfra) {
          $('#' + id).css('border', '2px solid #ff672d');
        } else {
          $('#' + id).css('border', 'transparent');
        }
      }
    });
  }
  updateSetting() {
    this.changed.emit(this.selectedCloudInfra);
  }
  selectCloudInfra(index) {
    if (this.cloudInfraList[index]['value'] === 'aws' || this.displayOnly === true) {
      this.selectedCloudInfra = this.cloudInfraList[index];
      this.selectedCloudInfraOutput.emit(this.selectedCloudInfra);
      this.ciSelected = this.selectedCloudInfra['cloudProvider'];
      this.regionSelected = this.selectedCloudInfra['region'];
      for (let i = 0; i < this.cloudInfraList.length; i++) {
        const id = 'selectedCloudInfra' + i;
        if (index === i) {
          $('#' + id).css('border', '2px solid #ff672d');
        } else {
          $('#' + id).css('border', 'transparent');
        }
      }
    } else {
      alert('Thank you for choosing this service. Use of this service requires additional settings including configuration of payment methods. You can sign up now with default option and change your settings after successfully logging into Platform Console.');
      this.emailTemplateInstance.notifyPartnerOnboarding.to.value[0].infrastructure = this.cloudInfraList[index]['value'];
    }
  }

}
